angular.module('TetherApp').factory('supportService', [
    '$http',
    function ($http) {

        let sendSupport = function (email, message) {
            return $http.post(
                '/api/v1/user/support',
                {
                    email: email,
                    message: message
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            sendSupport: sendSupport
        }

    }
]);
